import loadable from '@loadable/component';
import Loading from '../../components/Loader';

export const AssessmentsPage = loadable(
  () =>
    import(/* webpackChunkName: "doe-assessment" */ '../../pages/Doe/assessments/AssessmentsPage'),
  {
    fallback: Loading,
  }
);
